import { useEffect, useState } from "react";
import Modal from "react-modal";
import styled from "styled-components";
import xBtn from "../../image/x.png";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import SaveAlert from "../Alert/SaveAlert";
import { useRecoilValue } from "recoil";
import { accessTokenAtom } from "../../recoil/auth";
import { deleteDevice } from "../../apis/api/Device/deleteDevice";
import { useTranslation } from "react-i18next";

function DeleteDeviceModal({ isOpen, isClose }) {
  const accessToken = useRecoilValue(accessTokenAtom);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const queryClient = useQueryClient();
  const [deviceList, setDeviceList] = useState([]);
  const deleteDeviceMutation = useMutation(deleteDevice, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["devices"] });
      SaveAlert();
      closeModal();
    },
  });

  useEffect(() => {
    if (isOpen === true) {
      const deviceData = queryClient.getQueryData(["devices"]);
      setDeviceList(deviceData);
      setModalIsOpen(true);
    } else {
      closeModal();
    }
  }, [isOpen]);

  function closeModal() {
    setModalIsOpen(false);
    isClose(false);
  }

  const onVaild = (formData) => {
    deleteDeviceMutation.mutate({ formData, accessToken });
  };

  const { t } = useTranslation();

  return (
    <Modal
      style={{
        overlay: {
          zIndex: 100,
          width: "100%",
          height: "100vh",
          backgroundColor: "rgba(100, 100, 100, 0.3)",
          transition: "opacity 0.5s ease",
          top: "0",
          position: "fixed",
        },
        content: {
          width: "500px",
          height: "fit-content",
          backgroundColor: "#ebecee",
          borderRadius: "15px",
          overflow: "hidden",
          position: "absolute",
          left: "50%",
          top: "45%",
          transform: `translate(-50%, -50%)`,
        },
      }}
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      ariaHideApp={false}
    >
      <ModalContainer>
        <Title>{t(`delete device`)}</Title>
        <XBtn onClick={closeModal} />
        <FormContainer>
          <InputForm onSubmit={handleSubmit(onVaild)}>
            <InputLabel>
              {t(`serial number`)}{" "}
              <ErrorMsg>{errors?.serial?.message}</ErrorMsg>
            </InputLabel>
            <Select {...register("serial", { required: `* ${t(`required`)}` })}>
              {deviceList?.map((device) => {
                return <Option key={device.serial}>{device.serial}</Option>;
              })}
            </Select>
            <Btn>{t(`delete`)}</Btn>
          </InputForm>
        </FormContainer>
      </ModalContainer>
    </Modal>
  );
}

const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  padding: 20px;
`;
const Title = styled.h1`
  font-weight: bold;
  font-size: 1.5rem;
  margin-bottom: 30px;
`;

const XBtn = styled.img.attrs({
  src: `${xBtn}`,
})`
  width: 25px;
  height: 25px;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 20px;
`;

const FormContainer = styled.div`
  background-color: white;
  border-radius: 10px;
  width: 90%;
  padding: 30px;
`;

const InputLabel = styled.label`
  margin-bottom: 10px;
  color: #6b6e6d;
  font-weight: 500;
`;

const Select = styled.select`
  border: none;
  border-bottom: 2px solid black;
  margin-bottom: 15px;
  font-size: 1rem;
`;

const Option = styled.option``;
const Btn = styled.button`
  margin-top: 20px;
  height: 50px;
  width: 100%;
  background-color: #ebecee;
  border: 1px solid #d8d8d8;
  transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  font-weight: bold;
  cursor: pointer;
  font-size: 1rem;
  &:hover {
    background-color: #ea54545e;
  }
`;
const InputForm = styled.form`
  display: flex;
  flex-direction: column;
`;

export const ErrorMsg = styled.span`
  height: 30px;
  color: red;
  padding-top: 3px;
  width: 100%;
`;

export default DeleteDeviceModal;
